<kgr-modal [open]="open$ | async" title="Login" (closeModal)="onClose()" width="980px">
  <kgr-modal-header headline="Login" i18n-headline></kgr-modal-header>
  <kgr-modal-content>
    @if (open$ | async) {
      <kgr-login-form [showEvenIfAlreadyLoggedIn]="true" (loginResult)="onLoginResult($event)"></kgr-login-form>
    }
  </kgr-modal-content>
</kgr-modal>
